import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SharedModule } from '@aiwyn/shared';
import { ROUTE_TOKEN_CXP_TASKS, ROUTE_TOKEN_MAIN_BASE } from '../../../../../../routing-constants';

const DESCRIPTION_TRUNCATION_THRESHOLD = 320;

@Component({
  selector: 'cxp-deliverable-detail-header',
  templateUrl: './deliverable-detail-header.component.html',
  styleUrls: ['./deliverable-detail-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, RouterLink],
})
export class DeliverableDetailHeaderComponent {
  readonly name = input.required<string>();
  /**
   * Heading text when it differs from the breadcrumb's leaf. The eSign detail
   * page titles itself `E-Sign: {name}` while its breadcrumb stays the plain
   * request name, so the two cannot both read `name`.
   */
  readonly title = input<string | null>(null);
  /** Root crumb label — `Requests` for deliverables, `Tasks` for eSign. */
  readonly breadcrumbRootLabel = input<string>('Requests');
  readonly serviceLineName = input<string | null>(null);
  readonly clientName = input<string | null>(null);
  readonly description = input<string>('');

  readonly tasksLink = [`/${ROUTE_TOKEN_MAIN_BASE}`, ROUTE_TOKEN_CXP_TASKS];

  readonly tasksNavigated = output<void>();

  private readonly expanded = signal(false);

  readonly isTruncatable = computed(
    () => (this.description() ?? '').length > DESCRIPTION_TRUNCATION_THRESHOLD,
  );

  readonly displayedDescription = computed(() => {
    const full = this.description() ?? '';
    if (!this.isTruncatable() || this.expanded()) return full;
    return full.slice(0, DESCRIPTION_TRUNCATION_THRESHOLD).trimEnd() + '…';
  });

  readonly toggleLabel = computed(() => (this.expanded() ? 'View Less' : 'View More'));

  readonly displayedTitle = computed(() => this.title() ?? this.name());

  toggleExpanded(): void {
    this.expanded.update((v) => !v);
  }

  onTasksClicked(): void {
    this.tasksNavigated.emit();
  }
}
